import React from "react";
import type { CaseStudyContent } from "../../data/caseStudies";
import { CaseStudySection } from "./CaseStudySection";
import { BODY, H2, H3 } from "../../utils/typography";
type ResultsSectionProps = {
  results: CaseStudyContent["results"];
};
export function ResultsSection({
  results
}: ResultsSectionProps) {
  if (results.kind === "shifts") {
    return <CaseStudySection label={results.heading} data-id="element-180" data-mp="2m12uc4e5ykp4">
        <ul className={`grid grid-cols-1 gap-10 md:gap-8 ${results.items.length === 4 ? "md:grid-cols-2 md:gap-y-12" : "md:grid-cols-3"}`} data-id="element-181" data-mp="39pvl7mfxi2cv">
          {results.items.map(item => <li key={item.value} data-id="element-182" data-mp="2zyr6mnu60jik">
              <p className={`${H3} text-rust`} data-id="element-183" data-mp="34xucgahyytrl">
                {item.value}
              </p>
              {item.label && <h3 className={`mt-4 ${BODY} font-medium text-espresso`} data-id="element-184" data-mp="3sn6jb3ptqpqq">{item.label}</h3>}
              {item.detail && <p className={`mt-2 ${BODY} text-espresso/70`} data-id="element-185" data-mp="19k7a7n786mb">{item.detail}</p>}
            </li>)}
        </ul>
      </CaseStudySection>;
  }
  const [lead, ...supporting] = results.items;
  return <CaseStudySection label={results.heading} data-id="element-186" data-mp="3kb3rg8occokf">
      {lead && <div data-id="element-187" data-mp="2tkm8vriis9a">
          <p className={`${H2} text-rust`} data-id="element-188" data-mp="2u2pwdgi88r8">
            {lead.value}
          </p>
          <p className="mt-3 text-sm font-medium uppercase tracking-wide text-espresso" data-id="element-189" data-mp="3u88d87e9yi0p">{lead.label}</p>
          {lead.detail && <p className={`mt-2 max-w-lg ${BODY} text-espresso/70`} data-id="element-190" data-mp="btg058cgd1d0">{lead.detail}</p>}
        </div>}
      {supporting.length > 0 && <ul className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 sm:gap-8" data-id="element-191" data-mp="6uwc92eatfi0">
          {supporting.map(item => <li key={item.value} data-id="element-192" data-mp="lq2klw0v9qei">
              <p className={`${H3} text-espresso`} data-id="element-193" data-mp="gssipgwajm9s">
                {item.value}
              </p>
              <p className="mt-3 text-sm font-medium uppercase tracking-wide text-espresso" data-id="element-194" data-mp="2nja0b6ke6a0x">{item.label}</p>
              {item.detail && <p className={`mt-2 ${BODY} text-espresso/70`} data-id="element-195" data-mp="2im0ahpt3bwck">{item.detail}</p>}
            </li>)}
        </ul>}
      {results.note && <p className="mt-10 max-w-xl text-sm text-espresso/70" data-id="element-196" data-mp="38b73eyfpwbb8">{results.note}</p>}
    </CaseStudySection>;
}